// extracted by mini-css-extract-plugin
module.exports = {"clause":"Clause_clause__16TqE","title":"Clause_title__1xTXk","one":"Clause_one__304On","msg":"Clause_msg__3azxb","two":"Clause_two__1jG2U","a":"Clause_a__3ThUk"};